/**
 * Debug utility for conditional logging
 * Only logs in development mode to reduce console noise in production
 */

const isDevelopment = process.env.NODE_ENV === 'development';
const DEBUG_ENABLED = process.env.REACT_APP_DEBUG === 'true' || isDevelopment;

/**
 * Log debug messages (development only)
 * @param {...any} args - Arguments to log
 */
export const debugLog = (...args) => {
  if (DEBUG_ENABLED) {
    console.log(...args);
  }
};

/**
 * Log debug warnings (development only)
 * @param {...any} args - Arguments to log
 */
export const debugWarn = (...args) => {
  if (DEBUG_ENABLED) {
    console.warn(...args);
  }
};

/**
 * Log errors (always logged, even in production)
 * @param {...any} args - Arguments to log
 */
export const debugError = (...args) => {
  console.error(...args);
};

/**
 * Log info messages (development only)
 * @param {...any} args - Arguments to log
 */
export const debugInfo = (...args) => {
  if (DEBUG_ENABLED) {
    console.info(...args);
  }
};

/**
 * Group related debug logs
 * @param {string} label - Group label
 * @param {Function} fn - Function to execute within the group
 */
export const debugGroup = (label, fn) => {
  if (DEBUG_ENABLED) {
    console.group(label);
    try {
      fn();
    } finally {
      console.groupEnd();
    }
  } else {
    fn();
  }
};

/**
 * Group related debug logs (collapsed by default)
 * Supports both sync and async functions
 * @param {string} label - Group label
 * @param {Function} fn - Function to execute within the group
 */
export const debugGroupCollapsed = (label, fn) => {
  if (DEBUG_ENABLED) {
    console.groupCollapsed(label);
    try {
      const result = fn();
      // If function returns a promise, wait for it before closing group
      if (result && typeof result.then === 'function') {
        result.finally(() => {
          console.groupEnd();
        });
        return result;
      } else {
        console.groupEnd();
        return result;
      }
    } catch (error) {
      console.groupEnd();
      throw error;
    }
  } else {
    return fn();
  }
};

/**
 * Time a function execution (development only)
 * @param {string} label - Timer label
 * @param {Function} fn - Function to time
 */
export const debugTime = (label, fn) => {
  if (DEBUG_ENABLED) {
    console.time(label);
    try {
      return fn();
    } finally {
      console.timeEnd(label);
    }
  }
  return fn();
};



